module.exports = __webpack_public_path__ + "img/2.71cef28b.jpg";